import { SET_DARK_MODE } from './actions';

const getInitialDarkMode = () => {

  const isAuthPage = window.location.pathname === '/login' ||
    window.location.pathname === '/logout' ||
    window.location.pathname === '/auth' ||
    window.location.pathname === '/recover-password' ||
    window.location.pathname === '/new-password';

  if (isAuthPage) {
    return false;
  }
  try {
    const stored = localStorage.getItem('@polichat/darkmode');
    if (stored !== null) {
      return JSON.parse(stored);
    }

    return false;
  } catch {
    return false;
  }
};

const INITIAL_STATE = {
  isDarkMode: getInitialDarkMode(),
};

export default function themeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_DARK_MODE:
      return {
        ...state,
        isDarkMode: action.payload,
      };
    default:
      return state;
  }
}
